export default {"src":"/_next/static/media/enforce-least-privileged-access.2ade2430.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};